import { createSlice, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

const globalInitialState = {
  isLoading: false,
  status: "default",
  message: "",
};

const globalSlice = createSlice({
  name: "global",
  initialState: globalInitialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
  },
});

const dashboardInitialState = {
  summary: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: dashboardInitialState,
  reducers: {
    setDashboardSummary: (state, action) => {
      state.summary = action.payload;
    },
  },
});

const userInitialState = {
  user_data: {},
  accessToken: null,
  currentPin: null,
  websiteUser: null,
};

const userSlice = createSlice({
  name: "user",
  initialState: userInitialState,
  reducers: {
    setDataUser: (state, action) => {
      state.user_data = action.payload;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setCurrentPin: (state, action) => {
      state.currentPin = action.payload;
    },
    setWebsiteUser: (state, action) => {
      state.websiteUser = action.payload;
    },
  },
});

const karyawanInitialState = {
  list_karyawan: [],
  list_karyawan_web: [],
  pagination_karyawan_web: null,
  options_karyawan_web: null,
  list_karyawan_belum_gaji: [],
  list_tabungan_karyawan: [],
  list_rekap_tabungan_karyawan: [],
  summary_absensi: null,
  list_cabang: [],
};

const karyawanSlice = createSlice({
  name: "karyawan",
  initialState: karyawanInitialState,
  reducers: {
    setListKaryawan: (state, action) => {
      state.list_karyawan = action.payload;
    },
    setListKaryawanWeb: (state, action) => {
      state.list_karyawan_web = action.payload.list;
      state.pagination_karyawan_web = action.payload.pagination ?? null;
    },
    setOptionsKaryawanWeb: (state, action) => {
      state.options_karyawan_web = action.payload;
    },
    setListKaryawanNotInputGaji: (state, action) => {
      state.list_karyawan_belum_gaji = action.payload;
    },
    setListTabunganKaryawan: (state, action) => {
      state.list_tabungan_karyawan = action.payload;
    },
    setListRekapTabunganKaryawan: (state, action) => {
      state.list_rekap_tabungan_karyawan = action.payload;
    },
    setSummaryAbsensi: (state, action) => {
      state.summary_absensi = action.payload;
    },
    resetSummaryAbsensi: (state) => {
      state.summary_absensi = null;
    },
    setListCabang: (state, action) => {
      state.list_cabang = action.payload;
    },
  },
});

const divisiInitialState = {
  list_divisi: [],
};

const divisiSlice = createSlice({
  name: "divisi",
  initialState: divisiInitialState,
  reducers: {
    setListDivisi: (state, action) => {
      state.list_divisi = action.payload;
    },
  },
});

const jabatanInitialState = {
  list_jabatan: [],
};

const jabatanSlice = createSlice({
  name: "jabatan",
  initialState: jabatanInitialState,
  reducers: {
    setListJabatan: (state, action) => {
      state.list_jabatan = action.payload;
    },
  },
});

const departemenInitialState = {
  list_departemen: [],
};

const departementSlice = createSlice({
  name: "departement",
  initialState: departemenInitialState,
  reducers: {
    setListDepartemen: (state, action) => {
      state.list_departemen = action.payload;
    },
  },
});

const notifikasiInitialState = {
  list_notifikasi: [],
};

const notifikasiSlice = createSlice({
  name: "notifikasi",
  initialState: notifikasiInitialState,
  reducers: {
    setListNotifikasi: (state, action) => {
      state.list_notifikasi = action.payload;
    },
  },
});

const panduanInitialState = {
  list_panduan: [],
};

const panduanSlice = createSlice({
  name: "panduan",
  initialState: panduanInitialState,
  reducers: {
    setListPanduan: (state, action) => {
      state.list_panduan = action.payload;
    },
  },
});

const aspirasiInitialState = {
  list_aspirasi: [],
};

const aspirasiSlice = createSlice({
  name: "aspirasi",
  initialState: aspirasiInitialState,
  reducers: {
    setListAspirasi: (state, action) => {
      state.list_aspirasi = action.payload;
    },
  },
});

const peringatanInitialState = {
  list_peringatan: [],
  pagination_peringatan: null,
};

const peringatanSlice = createSlice({
  name: "peringatan",
  initialState: peringatanInitialState,
  reducers: {
    setListPeringatan: (state, action) => {
      state.list_peringatan = action.payload.list;
      state.pagination_peringatan = action.payload.pagination ?? null;
    },
  },
});

const jenjangInitialState = {
  list_jenjang: [],
  pagination_jenjang: null,
};

const jenjangSlice = createSlice({
  name: "jenjang",
  initialState: jenjangInitialState,
  reducers: {
    setListJenjang: (state, action) => {
      state.list_jenjang = action.payload.list;
      state.pagination_jenjang = action.payload.pagination ?? null;
    },
  },
});

const stockopnameInitialState = {
  list_stockopname: [],
  list_peserta_so: [],
  list_karyawan_so: [],
};

const stockopnameSlice = createSlice({
  name: "stockopname",
  initialState: stockopnameInitialState,
  reducers: {
    setListStockopname: (state, action) => {
      state.list_stockopname = action.payload;
    },
    setListPeserta: (state, action) => {
      state.list_peserta_so = action.payload;
    },
    setListKaryawanSO: (state, action) => {
      state.list_karyawan_so = action.payload;
    },
  },
});

const absensiInitialState = {
  list_absensi_hariini: [],
  list_absensi_bulanan: [],
  pagination_absensi_bulanan: null,
  options_absensi_bulanan: null,
  list_absensi_harian: [],
  pagination_absensi_harian: null,
  options_absensi_harian: null,
};

const absensiSlice = createSlice({
  name: "absensi",
  initialState: absensiInitialState,
  reducers: {
    setListAbsensiHariIni: (state, action) => {
      state.list_absensi_hariini = action.payload;
    },
    setListAbsensiBulanan: (state, action) => {
      state.list_absensi_bulanan = action.payload.list;
      state.pagination_absensi_bulanan = action.payload.pagination ?? null;
    },
    setOptionsAbsensiBulanan: (state, action) => {
      state.options_absensi_bulanan = action.payload;
    },
    setListAbsensiHarian: (state, action) => {
      state.list_absensi_harian = action.payload.list;
      state.pagination_absensi_harian = action.payload.pagination ?? null;
    },
    setOptionsAbsensiHarian: (state, action) => {
      state.options_absensi_harian = action.payload;
    },
  },
});

const setoranInitialState = {
  list_setoran: [],
  pagination_setoran: null,
  options_setoran: null,
  list_pencapaian: [],
  pagination_pencapaian: null,
  totals_pencapaian: null,
  detail_setoran_harian: null,
  pengeluaran_setoran: null,
  pengeluaran_setoran_global: null,
};

const setoranSlice = createSlice({
  name: "setoran",
  initialState: setoranInitialState,
  reducers: {
    setListSetoran: (state, action) => {
      state.list_setoran = action.payload.list ?? action.payload;
      state.pagination_setoran = action.payload.pagination ?? null;
    },
    setOptionsSetoran: (state, action) => {
      state.options_setoran = action.payload;
    },
    setListPencapaian: (state, action) => {
      state.list_pencapaian = action.payload.list ?? action.payload;
      state.pagination_pencapaian = action.payload.pagination ?? null;
      state.totals_pencapaian = action.payload.totals ?? null;
    },
    setDetailSetoranHarian: (state, action) => {
      state.detail_setoran_harian = action.payload;
    },
    resetDetailSetoranHarian: (state, action) => {
      state.detail_setoran_harian = null;
    },
    setPengeluaranSetoran: (state, action) => {
      state.pengeluaran_setoran = action.payload;
    },
    setPengeluaranSetoranGlobal: (state, action) => {
      state.pengeluaran_setoran_global = action.payload;
    },
    resetPengeluaranSetoran: (state, action) => {
      state.pengeluaran_setoran = null;
    },
  },
});

const gajiInitialState = {
  list_gaji: [],
};

const gajiSlice = createSlice({
  name: "gaji",
  initialState: gajiInitialState,
  reducers: {
    setListGaji: (state, action) => {
      state.list_gaji = action.payload;
    },
  },
});

const cabangInitialState = {
  list_cabang: [],
};

const cabangSlice = createSlice({
  name: "cabang",
  initialState: cabangInitialState,
  reducers: {
    changeListCabang: (state, action) => {
      state.list_cabang = action.payload;
    },
  },
});

const alokasiInitialState = {
  list_transaksi_warkat: [],
  list_transaksi: [],
  list_perkiraan: [],
  list_setoran_percabang: [],
};

const alokasiSlice = createSlice({
  name: "alokasi",
  initialState: alokasiInitialState,
  reducers: {
    setListTransaksiWarkat: (state, action) => {
      state.list_transaksi_warkat = action.payload;
    },
    setListTransaksi: (state, action) => {
      state.list_transaksi = action.payload;
    },
    setListPerkiraan: (state, action) => {
      state.list_perkiraan = action.payload;
    },
    setListSetoranPerCabang: (state, action) => {
      state.list_setoran_percabang = action.payload;
    },
  },
});

const persistConfig = {
  key: "user",
  storage,
};

const rootReducer = combineReducers({
  global: globalSlice.reducer,
  dashboard: dashboardSlice.reducer,
  user: persistReducer(persistConfig, userSlice.reducer),
  karyawan: karyawanSlice.reducer,
  notifikasi: notifikasiSlice.reducer,
  so: stockopnameSlice.reducer,
  absensi: absensiSlice.reducer,
  divisi: divisiSlice.reducer,
  jabatan: jabatanSlice.reducer,
  departemen: departementSlice.reducer,
  panduan: panduanSlice.reducer,
  aspirasi: aspirasiSlice.reducer,
  peringatan: peringatanSlice.reducer,
  setoran: setoranSlice.reducer,
  gaji: gajiSlice.reducer,
  cabang: cabangSlice.reducer,
  jenjang: jenjangSlice.reducer,
  alokasi: alokasiSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };
export const { setIsLoading, setStatus, setMessage } = globalSlice.actions;
export const { setDashboardSummary } = dashboardSlice.actions;
export const { setDataUser, setAccessToken, setCurrentPin, setWebsiteUser } = userSlice.actions;
export const {
  setListKaryawan,
  setListKaryawanWeb,
  setOptionsKaryawanWeb,
  setListKaryawanNotInputGaji,
  setListTabunganKaryawan,
  setListRekapTabunganKaryawan,
  setSummaryAbsensi,
  resetSummaryAbsensi,
  setListCabang,
} = karyawanSlice.actions;
export const { setListDepartemen } = departementSlice.actions;
export const { changeListCabang } = cabangSlice.actions;
export const { setListDivisi } = divisiSlice.actions;
export const { setListJabatan } = jabatanSlice.actions;
export const { setListNotifikasi } = notifikasiSlice.actions;
export const { setListPanduan } = panduanSlice.actions;
export const { setListAspirasi } = aspirasiSlice.actions;
export const { setListPeringatan } = peringatanSlice.actions;
export const { setListJenjang } = jenjangSlice.actions;
export const { setListStockopname, setListPeserta, setListKaryawanSO } =
  stockopnameSlice.actions;
export const {
  setListAbsensiHariIni,
  setListAbsensiBulanan,
  setOptionsAbsensiBulanan,
  setListAbsensiHarian,
  setOptionsAbsensiHarian,
} = absensiSlice.actions;
export const {
  setListSetoran,
  setOptionsSetoran,
  setListPencapaian,
  setDetailSetoranHarian,
  resetDetailSetoranHarian,
  setPengeluaranSetoran,
  setPengeluaranSetoranGlobal,
  resetPengeluaranSetoran,
} = setoranSlice.actions;
export const { setListGaji } = gajiSlice.actions;
export const {
  setListTransaksi,
  setListPerkiraan,
  setListTransaksiWarkat,
  setListSetoranPerCabang,
} = alokasiSlice.actions;
